module.exports = __webpack_public_path__ + "static/img/logo.9c371be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = 365
// module chunks = 2